import type { ResponsiveType } from 'react-multi-carousel';

import MultiCarousel from '@/app/components/MultiCarousel';
import { RESPONSIVE_DATA } from '@/app/components/MultiCarousel/constants';

import type { CardQuoteProps } from './CardQuote';
import CardQuote from './CardQuote';

const QUOTES: CardQuoteProps[] = [
  {
    quote: 'pdp_horizon_quote_1_text',
    name: 'Matthew Walker',
    affiliation: '@drmattwalker',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-walker@2x',
  },
  {
    quote: 'pdp_horizon_quote_2_text',
    name: 'Shara Raqs',
    affiliation: '@shara.raqs',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-shara@2x',
  },
  {
    quote: 'pdp_horizon_quote_3_text',
    name: 'Odell Beckham Junior',
    affiliation: '@obj',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-obj@2x',
  },
  {
    quote: 'pdp_horizon_quote_4_text',
    name: 'Jenny McGuckian',
    affiliation: '@gonourishwithjenny',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-jenny@2x',
  },
  {
    quote: 'pdp_horizon_quote_5_text',
    name: 'Katie Ledecky',
    affiliation: '@katieledecky',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-ledecky@2x',
  },
  {
    quote: 'pdp_horizon_quote_6_text',
    name: 'August Marie Ball',
    affiliation: '@philosophica82',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-amb@2x',
  },
  {
    quote: 'pdp_horizon_quote_7_text',
    name: 'Pam',
    affiliation: '@pamelabaizas',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-pam@2x',
  },
  {
    quote: 'pdp_horizon_quote_8_text',
    name: 'Chris Paul',
    affiliation: '@cp3',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-cp3@2x',
  },
  {
    quote: 'pdp_horizon_quote_9_text',
    name: 'Jess',
    affiliation: '@scijess',
    avatarUrl: 'product/simple/pdp-community-quote-avatar-jess@2x',
  },
];

const RESPONSIVE = {
  desktop: { ...RESPONSIVE_DATA['desktop'], items: 5 },
  tablet: { ...RESPONSIVE_DATA['tablet'], items: 2 },
  mobile: { ...RESPONSIVE_DATA['mobile'], items: 1 },
} as ResponsiveType;

const QuoteSlider = (): JSX.Element => {
  return (
    <MultiCarousel
      arrows={false}
      autoPlay
      autoPlaySpeed={5000}
      customTransition="all 5s linear"
      infinite
      pauseOnHover
      responsive={RESPONSIVE}
      rewind={false}
      rewindWithAnimation={false}
      shouldResetAutoplay
      showDots={false}
    >
      {QUOTES.map((props, idx) => (
        <div key={idx}>
          <CardQuote {...props} />
        </div>
      ))}
    </MultiCarousel>
  );
};

export default QuoteSlider;
